import Link from 'next/link'
import clsx from 'clsx'
import { isValid } from 'date-fns'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'
import { Card } from '@wartek-id/card'

import { formatDate } from 'utils/datetime'
import usePenetapanCountDinas from 'app/KinerjaDinasPage/hooks/usePenetapanCountDinas'
import { PENGELOLAAN_KINERJA_KADIN_PATH } from 'app/KinerjaShared/constants/path'
import { assetUrl } from 'utils/url'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'
import CircularProgressV2 from 'app/KinerjaPSPage/components/CircularProgressV2'
import usePenetapanGuard from 'app/KinerjaDinasPage/hooks/usePenetapanGuard'
import { useIsPrior2025 } from 'app/KinerjaShared/hooks/useIsPrior2025'

export const illustration = assetUrl('/illustrations/img-pengecekan-data.png')

const CardPenetapan = ({
  className,
  vertical = false,
}: {
  className?: string
  vertical?: boolean
}) => {
  const isPriorTo2025 = useIsPrior2025()
  const {
    isLoading: isLoadingPengawasProfile,
    profilePs: pengawasProfile,
    isKepalaDinas,
    leave,
  } = useRoleContext()
  if (!isLoadingPengawasProfile && !isKepalaDinas) leave()

  const { isLoading: isLoadingSchoolCount, data: counter } =
    usePenetapanCountDinas({ enabled: !!pengawasProfile })

  const { isStarted, startDate } = usePenetapanGuard()

  return (
    <Card className={clsx('flex-1', className)}>
      <section
        className={clsx('flex gap-6 p-6 h-full', {
          'flex-row items-center': !vertical,
          'flex-col': vertical,
        })}
      >
        <div className="w-20 flex flex-col items-center flex-none flex-shrink-0">
          <CircularProgressV2
            isLoading={isLoadingSchoolCount}
            value={counter?.sudahDikirim || 0}
            maxValue={counter?.all || 0}
          />
        </div>

        <div className="space-y-4 flex-1">
          <div className="space-y-1">
            <Text variant="heading-lg">Penetapan Predikat Kinerja</Text>
            <Text variant="body-lg" color="subdued">
              {isPriorTo2025
                ? 'Cek rekomendasi dari Tim Kinerja di sini.'
                : 'Tetapkan berdasarkan rekomendasi dari Tim Kinerja.'}
            </Text>
          </div>
        </div>

        <div className="flex-0">
          <Link href={`${PENGELOLAAN_KINERJA_KADIN_PATH}/penetapan`} passHref>
            <Button
              as="a"
              className="w-52 text-center"
              color="black"
              disabled={!isStarted}
              role="link"
              size="lg"
              type={undefined}
            >
              {isStarted || !isValid(startDate)
                ? 'Lakukan'
                : `Tersedia mulai ${formatDate(startDate)}`}
            </Button>
          </Link>
        </div>
      </section>
    </Card>
  )
}
export default CardPenetapan
